// @ts-ignore
export default function (href: string, name: string){
    const link = document.createElement('a');
    link.href = href;
    link.download = name;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}